function presentmentRateFromShopify() {
  const c = typeof Shopify !== 'undefined' && Shopify.currency;
  if (c && c.rate != null && c.rate !== '') {
    const r = parseFloat(c.rate, 10);
    return isNaN(r) ? 1 : r;
  }
  return 1;
}

function thresholdPresentmentMinor(root) {
  const shop = root.getAttribute('data-shop-currency') || '';
  const cartCur = root.getAttribute('data-cart-currency') || '';
  const base = parseInt(root.getAttribute('data-threshold-shop-minor'), 10) || 0;
  if (shop === cartCur) return base;
  return Math.round(base * presentmentRateFromShopify());
}

function formatRemainingMoney(cents) {
  if (!theme.utils || typeof theme.utils.formatMoney !== 'function') {
    return String(cents);
  }
  let s = theme.utils.formatMoney(cents);
  return s.replace(/\.00$/, '').replace(/,00$/, '');
}

function applyFreeShippingBar(host) {
  const el = host || document.querySelector('#free-shipping-bar');
  if (!el) return;
  const root = el.querySelector('.free-shipping-bar__root');
  if (!root) return;

  const itemCount = parseInt(root.getAttribute('data-item-count'), 10) || 0;
  root.style.display = itemCount < 1 ? 'none' : '';

  const msgEl = root.querySelector('.shipping-bar__message');
  const progressEl = root.querySelector('.free-shipping__progress');
  const promote = root.getAttribute('data-promote') || '';
  const unlocked = root.getAttribute('data-unlocked') || '';
  const threshold = thresholdPresentmentMinor(root);
  const total = parseInt(root.getAttribute('data-cart-total-minor'), 10) || 0;

  if (!msgEl || !progressEl) return;

  if (threshold <= 0) {
    msgEl.textContent = unlocked;
    msgEl.classList.add('shipping-bar-success');
    progressEl.style.width = '100%';
    return;
  }

  const remaining = threshold - total;
  if (remaining <= 0) {
    msgEl.textContent = unlocked;
    msgEl.classList.add('shipping-bar-success');
    progressEl.style.width = '100%';
  } else {
    msgEl.textContent = promote.split('[value]').join(formatRemainingMoney(remaining));
    msgEl.classList.remove('shipping-bar-success');
    progressEl.style.width = Math.min(100, Math.floor((total * 100) / threshold)) + '%';
  }
}

window.applyFreeShippingBar = applyFreeShippingBar;

class FreeShippingBar extends HTMLElement {
  constructor() {
    super();
  }
  static async refresh() {
    fetch('/')
      .then((response) => response.text())
      .then((response) => {
        let newHtml = new DOMParser().parseFromString(response, 'text/html');
        const cur = document.querySelector('#free-shipping-bar');
        const next = newHtml.querySelector('#free-shipping-bar');
        if (cur && next) {
          cur.innerHTML = next.innerHTML;
          applyFreeShippingBar(cur);
        }
      });
  }
  async refresh() {
    fetch('/')
      .then((response) => response.text())
      .then((response) => {
        let newHtml = new DOMParser().parseFromString(response, 'text/html');
        const cur = document.querySelector('#free-shipping-bar');
        const next = newHtml.querySelector('#free-shipping-bar');
        if (cur && next) {
          cur.innerHTML = next.innerHTML;
          applyFreeShippingBar(cur);
        }
      });
  }
}

customElements.define('free-shipping-bar', FreeShippingBar);

document.addEventListener('DOMContentLoaded', () => applyFreeShippingBar());
window.on('theme:cart:updated', () => applyFreeShippingBar());
